import { useCaptureStore } from "../../Stores/Capture";
import { CaptureEditor } from "./CaptureEditor";

/**
 * Mounts the annotation editor while the capture store has a screenshot open
 * (host `capture-image`). Renders nothing — and costs nothing — otherwise.
 */
export const CaptureEditorHost = () => {
  const editor = useCaptureStore((state) => state.editor);
  if (!editor) {
    return null;
  }
  return (
    <CaptureEditor
      key={editor.sessionId}
      imageSrc={editor.dataUrl}
      annotate={editor.annotate}
      canRetake={editor.canRetake}
      sending={editor.phase === "sending"}
      progress={editor.progress}
      hasError={editor.phase === "error"}
      onSend={(result) => useCaptureStore.getState().sendEditorResult(result)}
      onRetake={() => useCaptureStore.getState().retakeFromEditor()}
      onCancel={() => useCaptureStore.getState().cancelEditor()}
    />
  );
};
